interface IWhiteList {
  name: string;
  code: string;
  apiDomain: string;
  version: number;
}

export const configVersion = 8;

export const webshopRegex = /https:\/\/.*\.ag\.ch/;
export const scanAccountIdentifier = 'gr';

export const cantonWhitelist = [
  {
    name: 'Fishven Aargau',
    code: 'aargau',
    apiDomain: 'aargau-api.fishven.com',
    version: configVersion,
  },
] as IWhiteList[];
